import { IPolicyAPIRequestParams } from '@/models/PolicyAPI/interfaces/IPolicyAPIRequestParams';
import { UseQueryResult } from 'react-query';
import useSunnyQuery from '@/utils/hooks/react_query/useSunnyQuery';
import { IRequestWrap } from '@/server/IServer';
import { PolicyAPIActions } from '@/models/PolicyAPI/PolicyAPIActions';
import { PolicyAPIClientRequestBuilder } from '@/models/PolicyAPI/PolicyRequestBuilder';
import reactQueryResponseHandler from '@/utils/hooks/react_query/reactQueryResponseHandler';

export const POLICY_API_FIND = 'policy_api_find';

export const findPolicy = (params: IPolicyAPIRequestParams, req?: IRequestWrap): Promise<string> => {
  const actions = new PolicyAPIActions(PolicyAPIClientRequestBuilder, req);
  const result = actions.find(params);
  return reactQueryResponseHandler(result);
};

const usePolicyAPIQuery = (params: IPolicyAPIRequestParams): UseQueryResult<string> => {
  return useSunnyQuery([POLICY_API_FIND, params.query.path], () => findPolicy(params));
};

export default usePolicyAPIQuery;
